import { UserEnumTextMapper } from "../data_models/enumToTextMapper";
import { FreelancerExperienceLevel } from "../data_models/freelancer";

/// Returns the string values of a string enum
export function getStringEnumValues(enumObj: Record<string, unknown>): string[] {
    return Object.values(enumObj) as string[];
}

/// Returns the numeric values of a numeric enum
export function getNumericEnumValues(enumObj: Record<string, unknown>): number[] {
    return Object.values(enumObj).filter(value => typeof value === 'number') as number[];
}



export const getFreelancerExperienceLevels = (): string[] => {
    return Object.values(FreelancerExperienceLevel).map(level =>
        UserEnumTextMapper.freelancerExperienceLevel(level as FreelancerExperienceLevel)
    );
};
